import { render, staticRenderFns } from "./materialScience_detail.vue?vue&type=template&id=0a05dc40&scoped=true"
import script from "./materialScience_detail.vue?vue&type=script&lang=js"
export * from "./materialScience_detail.vue?vue&type=script&lang=js"
import style0 from "./materialScience_detail.vue?vue&type=style&index=0&id=0a05dc40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05dc40",
  null
  
)

export default component.exports